
import axios from 'axios'
import {urlDomain } from '../config/constant'

const apiDomain = urlDomain();

export const glusr_details = (ak, glid) =>{
  const url = `${apiDomain}/users/detail/?glusrid=${glid}&token=imobile@15061981&modid=LEAPIN&logo=1&others=ALL&AK=${ak}`
  
  return axios.get(url)
}

// Sends the encrypted glusr_usr_* PII fields to the Node backend and gets
// MASKED values back for display (e.g. "pa***n@g***.com", "*****4638"), plus
// any small derived booleans (e.g. isBlockedEmailDomain) the frontend needs.
// Node decrypts in memory to compute these — the real plaintext never
// crosses the network.
export const maskGlusrFields = (encryptedFields) => {
  const apiUrl = `${apiDomain}/users/maskFields`;
  return axios.post(apiUrl, encryptedFields)
}

export const additionDetails = (ak, glid) => {
  const apiUrl = `${apiDomain}/users/otherdetail/?glusrid=${glid}&token=imobile@15061981&modid=LEAPIN&type=CompRgst&AK=${ak}`;
  return axios.get(apiUrl)
}

// Recent Activity
export const getActivity = (empid, ak, glid) =>{

  const logDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const logTime = new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 8).replace(/:/g, '');
  const apiurl = `${apiDomain}/recentActivity?glusrId=${glid}&logtime=${logDate}${logTime}&AK=${ak}&empid=${empid}`

  return axios.get(apiurl)
}

export const updateAdditionalDataGST = (userIp, empid, ak, updateBy, glid, gstNumber) => {

  const apiUrl = `${apiDomain}/updateGST`

  const requestData = {
    userIp: userIp,
    userIpCoun: "India",
    updatedbyScreen: "Contact Center",
    VALIDATION_KEY: "622fa9ce30b491b431d38a142ca572c8",
    type: "CompRgst",
    updatedbyId: empid,
    updatedby: updateBy,
    glusridval: glid,
    GST: gstNumber,
    AK: ak,
  };

  return axios.post(apiUrl, requestData)

}

export const updateGlusrDetails = (requestData) => {
  const apiUrl = `${apiDomain}/user/update`;

  return axios.post(apiUrl, requestData)
}

export const lstStatus_updation = (glid, empid, ak,  emp_name, remoteIP) => {
  const apiUrl = `${apiDomain}/user/lstStatus_updation`;
  const requestData = {
    VALIDATION_KEY: "622fa9ce30b491b431d38a142ca572c8",
    MODID:"LEAPIN",
    UPDATEDBY: emp_name,
    UPDATEDBY_ID: empid,
    UPDATEDUSING: '9696 Process',
    USR_ID:glid,
    LISTING_STATUS:"TFL",
    IP_COUNTRY:"India",
    IP:remoteIP,
    HIST_COMMENTS:`Listing Status Updated by ${emp_name} using 9696 Process`,
    AK:ak
  }
  return axios.post(apiUrl, requestData)
}


export const getPCItems = (glid, ak) => {
  const apiURL = `${apiDomain}/products/userlisting/?token=imobile%4015061981&gluserid=${glid}&mod_id=LEAPIN&AK=${ak}`;

  return axios.get(apiURL);
}

export const displayVerified = (glid, ak) => {
  const apiURL = `${apiDomain}/users/verifiedDetail?token=imobile@15061981&modid=LEAPIN&glusrid=${glid}&AK=${ak}&attribute_id=106,120,2106`
  return axios.get(apiURL)
}

export const errorLogHandling = (url, reqParams, resParams) => {
  const apiUrl = `${apiDomain}/error-log`;
  const requestData = {
    url: url,
    method: "POST",
    reqParams: reqParams,
    resParams: resParams,
    process_l1: "new-crm-ui",
    process_l2: "#01",
    response_status: 200,
    total_time: new Date()
  }
  return axios.post(apiUrl, requestData)
}